import { render, staticRenderFns } from "./ConversionBasedOnAmountTransactionByPhrases.vue?vue&type=template&id=33586e17&scoped=true"
import script from "./ConversionBasedOnAmountTransactionByPhrases.vue?vue&type=script&lang=ts"
export * from "./ConversionBasedOnAmountTransactionByPhrases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33586e17",
  null
  
)

export default component.exports